import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

// Live Starter Kit sports/ages straight from /starter-kit/options (the same gate checkout uses).
export function useKitAvailability() {
  const [a, setA] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/starter-kit/options").then(({ data }) => {
      const live = (data.combos || []).filter((c) => c.available);
      const sports = [...new Set(live.map((c) => c.sport))];
      const nums = live.flatMap((c) => c.age.split("-").map(Number));
      cache = { sports, label: sports.length ? `${sports.join(" & ")}, ages ${Math.min(...nums)}-${Math.max(...nums)}` : "" };
      setA(cache);
    }).catch(() => {});
  }, []);
  return a || { sports: [], label: "" };
}
